module.exports = __webpack_public_path__ + "static/11-Table center piece-4b10b703c9b762065fb719d9fb848ab3.jpg";